import React, { useState, useEffect } from "react";
import queryString from "query-string";
import PropTypes from "prop-types";
import { setCookie } from "../../utils/cookies";
import ResetYourPassword from "../ResetYourPassword";
import ResetYourPasswordFromMail from "../ResetYourPasswordFromMail";

const PasswordReset = (props) => {
  const [showResetPassword, setShowResetPassword] = useState("");

  useEffect(() => {
    const {
      location: { search }
    } = props;
    let showPassword = true;
    const params = queryString.parse(search);
    let environment;
    const locationUrl = window.location.origin;
    if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
      environment = 'ctapproutedev';
    } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
      environment = 'ctapproutestg';
    } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
      environment = 'ctapproutedevc';
    } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
      environment = 'ctapproutepsup';    
    } else if (locationUrl.indexOf('login.ct.gov') > 0) {
      environment = 'ctapproute';
    }
    
    let ctapproute;
    if (params.code && params.token) {
      showPassword = false;
    }
    Object.keys(params).forEach((key) => {
      if (key === environment) {
        ctapproute = params[key];
      }
    });
    if (ctapproute) {
      setCookie(`${environment}`, ctapproute);
    }
    if (params.language) {
      setCookie("ctsessionlanguage", params.language);
    }
    setShowResetPassword(showPassword);
  }, [props]);

  return (
    <>
      {showResetPassword && <ResetYourPassword />}
      {showResetPassword !== "" && !showResetPassword && (
        <ResetYourPasswordFromMail />
      )}
    </>
  );
};

PasswordReset.propTypes = {
  location: PropTypes.object.isRequired
};

export default PasswordReset;
